import "@lottiefiles/lottie-player";
import {setHeaderHeight} from "./modules/setHeaderHeight.js";
import {initMegaMenu} from "./modules/megaMenu.js";
import {initLanguageSwitcher} from "./modules/languageSwitcher.js";

import.meta.glob([
	'../images/**',
	'../fonts/**',
]);

const loadIfPresent = (selector, callback) => {
	if (document.querySelector(selector)) {
		callback();
	}
};

document.addEventListener('DOMContentLoaded', function () {
	setHeaderHeight();
	initMegaMenu();
	initLanguageSwitcher();

	loadIfPresent('.wp-block-acf-accordion', async () => {
		const {blockAccordion} = await import("./blocks/accordions.js");
		blockAccordion();
	});

	loadIfPresent('.hero--slider', async () => {
		const {initHeroSlider} = await import("./blocks/hero.js");
		initHeroSlider();
	});

	loadIfPresent('.wp-block-acf-quicklinks', async () => {
		const {initQuicklinks} = await import("./blocks/quicklinks.js");
		initQuicklinks();
	});

	loadIfPresent('.wp-block-acf-produkte', async () => {
		const {initProdukte} = await import("./blocks/produkte.js");
		initProdukte();
	});

	loadIfPresent('.wp-block-acf-usps', async () => {
		const {initUsps} = await import("./blocks/usps.js");
		initUsps();
	});

	loadIfPresent('.wp-block-acf-schritte', async () => {
		const {initSchritte} = await import("./blocks/schritte.js");
		initSchritte();
	});

	loadIfPresent('.wp-block-acf-case-studies', async () => {
		const {initCaseStudies} = await import("./blocks/case-studies.js");
		initCaseStudies();
	});

	loadIfPresent('.wp-block-acf-foerderrechner', async () => {
		const {initFoerderrechner} = await import("./blocks/foerderrechner.js");
		initFoerderrechner();
	});

	loadIfPresent('.wp-block-acf-product-funktionen', async () => {
		const {initProductFunktionen} = await import("./blocks/product-funktionen.js");
		initProductFunktionen();
	});

	loadIfPresent('.wp-block-acf-product-slider', async () => {
		const {initProductSlider} = await import("./blocks/product-slider.js");
		initProductSlider();
	});

	loadIfPresent('.product-detail', async () => {
		const {initProductDetail} = await import("./blocks/product-detail.js");
		initProductDetail();
	});

	loadIfPresent('.product-cta', async () => {
		const {initProductShare} = await import("./blocks/product-share.js");
		initProductShare();
	});
}, false);